import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataManipService {

  public prefLanguage: string = "";
  public userName: string = "";
  public userId: number = null;
  public testId: number = null;
  public usertestid: number = null;
  public srno:number=0;
 // public registerby:string=""
  public testName: string = "";
  public testType: string = "";
  public testImgSrcBase64: string = "";
  public defaultTestImg = "../../../assets/img/courses-img/default-test-img.jpg";
  public testLangugae: string = "";
  public testInstructions = {};
  public requireddata = {};
  public currentServerDate = Date.now();
  public isadmin:boolean=false;
  public dob : any = undefined;
  public age: number = null;
  public userimage: string = '';
  public apiToken: string = '';

  public emailId: string = '';
  public mobileNo: number = null;


  public walletamount : number = null;

  public headerName:string = '';

  public trailTestObject: any = {};
  
  constructor() { }
}
